<template>
  <b-overlay :show="loading" rounded="sm">
    <template #overlay>
      <div class="text-center">
        <digger-loader />
      </div>
    </template>
    <b-container v-if="loadError" class="py-5 custom-container container">
      <b-alert
        show
        variant="danger"
        class="mt-3"
        data-testid="template-form-load-error"
      >
        {{ loadError }}
      </b-alert>
    </b-container>
    <transition v-if="template" name="bounce">
      <b-container class="py-5 custom-container container">
        <b-breadcrumb
          :items="items"
          class="pl-0 pt-5 mt-5 bg-transparent"
        ></b-breadcrumb>
        <h2 class="font-weight-bold">{{ template.label }}</h2>
        <b-card class="mt-4">
          <div class="mx-auto p-lg-5 w-75">
            <h4 class="font-weight-bold mb-4">File Details</h4>
            <file-form
              :file="file"
              :template="template.id"
              :requires-back="!!template.requires_back"
              :selectedFields="selectedInfoTypes"
              :hasSwitch="template.has_switch[0]"
              :is-request-file-creation="isRequestFileCreation"
              :request="request ? request.file_request : null"
              :back-to="backTo"
            />
          </div>
        </b-card>
      </b-container>
    </transition>
  </b-overlay>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FileForm from '@/components/forms/FileForm'
import { persistTradieUploadContext } from '@/utils/tradieUploadContext'

export default {
  components: {
    FileForm,
  },
  data() {
    return {
      loading: false,
      loadError: '',
      file: {
        name: '',
        uploadType: 'multiple',
      },
      selectedInfoTypes: null,
    }
  },
  computed: {
    items() {
      return [
        {
          text: 'File Upload',
          to: this.isRequestFileCreation
            ? `/request/file/${this.fileRequestUserId}/templates`
            : '/templates',
        },
      ]
    },
    backTo() {
      if (this.isRequestFileCreation) {
        return {
          name: 'request.request-file-templates-page',
          params: { fileRequestUserId: this.fileRequestUserId },
        }
      }
      return { name: 'templates.list-page' }
    },
    isRequestFileCreation() {
      return this.$route.name === 'request.request-file-template-form-page'
    },
    fileRequestUserId() {
      if (this.isRequestFileCreation) {
        return this.$route.params.fileRequestUserId
      } else {
        return null
      }
    },
    ...mapGetters('template', ['template']),
    ...mapGetters('requests', ['request']),
  },

  methods: {
    ...mapActions({
      getTemplate: 'template/getTemplate',
    }),
    ...mapActions('requests', ['getRequestByUser']),

    async fetchTemplate() {
      this.loading = true
      this.loadError = ''
      try {
        await this.getTemplate(this.$route.params.id)
        this.items.push({
          text: this.template.label,
        })
        this.file.name = this.template.label
        this.selectedInfoTypes = this.template.information_types
      } catch (err) {
        // Clear any previously loaded template so it doesn't keep rendering
        // behind the error banner.
        this.$store.commit('template/setTemplate', null)
        const status = err && err.response && err.response.status
        if (status === 403) {
          this.loadError = "You don't have access to this document type."
        } else if (status === 404) {
          this.loadError = 'This document type could not be found.'
        } else {
          this.loadError = 'Could not load this form.'
        }
      } finally {
        this.loading = false
      }
    },
  },

  async created() {
    persistTradieUploadContext(this.$route.query)

    if (this.isRequestFileCreation) {
      await this.getRequestByUser(this.$route.params.fileRequestUserId)
        .then(async () => {
          await this.fetchTemplate()
        })
        .catch((err) => {
          if (err.data && err.data.status === 404) {
            this.$router.replace({ name: 'page-not-found' })
          }
        })
    } else {
      await this.fetchTemplate()
    }
  },
}
</script>
